import {EventEmitter} from 'events';
import Dispatcher from 'common/events/dispatcher';

// Constants
const CHANGE_EVENT = 'change';
const ERROR_EVENT = 'error';

// Data structures that this store manipulates
let _reports = [];
let _meta = {};
let _error = null;

function _augmentReports(reports) {
  if ('errors' in reports) {
    // shape: {"errors": [{"message": "..."}]};
    throw reports.errors[0];
  }
  return {
    ...reports,
    data: reports.data.map((report) => ({
      ...report,
      // Previously used for cache busting
      srcParams: '',
    })),
  };
}

function _updateReportsDashboard(reports) {
  _reports = _augmentReports(reports);
  _meta = reports.meta;
}

const ReportsDashboardStore = {
  ...EventEmitter.prototype,
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  emitError() {
    this.emit(ERROR_EVENT);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  addErrorListener(callback) {
    this.on(ERROR_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  removeErrorListener(callback) {
    this.removeListener(ERROR_EVENT, callback);
  },

  getMeta() {
    return _meta;
  },

  getReports() {
    return _reports;
  },

  getError() {
    return _error;
  },
};

ReportsDashboardStore.dispatchToken = Dispatcher.register((payload) => {
  const action = payload.action;
  if (action === 'UPDATE_REPORTS_DASHBOARD') {
    _updateReportsDashboard(payload.reports);
    ReportsDashboardStore.emitChange();
  }
  if (action === 'ERROR_REPORTS_DASHBOARD') {
    _error = payload.error;
    ReportsDashboardStore.emitError();
  }
});

export default ReportsDashboardStore;
